import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const FlowLogoSquare = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g fill="none" fillRule="nonzero"><rect fill="#00EF8B" height={24} rx={0} width={24} /><path d="M13.766 13.497v-3.359h3.362V13.5h-3.361v1.26c0 .822-.22 1.628-.633 2.335l-.145.232a4.622 4.622 0 1 1-3.843-7.189h1.262v3.36H9.146a1.262 1.262 0 1 0 1.262 1.262v-1.262h3.358Zm1.262-5.04h3.78V5.095h-3.78a4.626 4.626 0 0 0-4.622 4.622v.421h3.36v-.421a1.262 1.262 0 0 1 1.262-1.26Z" fill="#FFF" /></g>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== rest || $[9] !== t2) {
    t4 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = className;
    $[8] = rest;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const FlowLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0ZM9.146 10.138a4.621 4.621 0 1 0 4.621 4.622V13.5h3.36v-3.362h-3.361l-.001 3.359h-3.357v1.263a1.262 1.262 0 1 1-1.262-1.262h1.262v-3.36h3.358v-.421a1.262 1.262 0 0 1 1.262-1.26h3.78V5.095h-3.78a4.626 4.626 0 0 0-4.622 4.622v.421h-1.26Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};